import { paths } from '@/config/paths'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { getTokenImage } from '@/ui/assets/tokens'
import { buttonVariants, LinkButton } from '@/ui/atoms/button/Button'
import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import { IconStack } from '@/ui/molecules/icon-stack/IconStack'
import { cn } from '@/ui/utils/style'

const TOKEN_ICON_PATHS = ['HYPE', 'UBTC', 'wstHYPE', 'UETH'].map(TokenSymbol).map((symbol) => getTokenImage(symbol))

interface CreatePositionPanelProps {
  title?: string
  href?: string
  className?: string
}

export function CreatePositionPanel({ title, href, className }: CreatePositionPanelProps) {
  return (
    <Panel.Wrapper className={className}>
      <Panel.Content className="flex flex-col gap-6 p-6 text-center md:px-8">
        <div className="flex flex-col items-center gap-6">
          <IconStack paths={TOKEN_ICON_PATHS} size="lg" stackingOrder="first-on-top" />
          <Typography variant="p" className="font-semibold sm:text-2xl">
            {title || 'Deposit your assets and borrow with our Easy Borrow Flow'}
          </Typography>
        </div>
        <div>
          <LinkButton className={cn(buttonVariants({ rounded: 'full' }), 'px-8')} href={href || paths.easyBorrow}>
            Create position
          </LinkButton>
        </div>
      </Panel.Content>
    </Panel.Wrapper>
  )
}
